import axios from './axiosInstance';

export const getCountries = async () => {

  try{
    const response = await axios({
      url : '/get-countries',
      method : 'GET'
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const getStates = async ({
  country
}) => {
  let params = {
    country : country
  };

  try{
    const response = await axios({
      url : '/get-states',
      method : 'GET',
      params : params
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const getCities = async ({
  country,
  state
}) => {

  let params = {
    country : country,
    state : state
  };

  try{
    const response = await axios({
      url : '/get-cities',
      method : 'GET',
      params : params
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}